import React from "react";
import { Avatar } from "@toddle-edu/ds-web";
import classes from "./TextWithAvatar.scss";

const TextWithAvatar = ({ columnData, id }) => {
  const { label, showAvatar, src, avatarId } = columnData;

  return (
    <div className={classes.container}>
      {showAvatar ? (
        <div>
          <Avatar src={src} id={avatarId ?? id} name={label} />
        </div>
      ) : null}
      <div className="truncate">{label}</div>
    </div>
  );
};

export default TextWithAvatar;
